import { request } from '@/common/utils/request'
export function getBrandVisitList(params) {
  return request
    .get({
      url: 'feidian.brand.getBrandContactsList', // 'feidian.brand.saveBrandContacts',
      params,
    })
    .then(res => res.data)
}
// 获取拜访对象初始化数据
export function getVisitObjectInit(params) {
  return request
    .get({
      url: 'feidian.brand.brandContactsInit', // feidian.brand.brandContactsInit',
      params,
    })
    .then(res => res.data)
}

// 保存
export function saveVisitObject(params) {
  return request
    .post({
      url: 'feidian.brand.saveBrandContacts', // 'feidian.brand.saveBrandContacts',
      params,
    })
    .then(res => res.data)
}
// Brand KP保存
export function saveVisitObjectV2(params) {
  return request
    .post({
      url: 'feidian.brandv2.saveBrandContacts', // 'feidian.brandv2.saveBrandContacts',
      params,
    })
    .then(res => res.data)
}
// Brand KP查询联系人
export function getBrandVisitListV2(params) {
  return request
    .get({
      url: 'feidian.brandv2.getBrandContactsList', // 'feidian.brand.saveBrandContacts',
      params,
    })
    .then(res => res.data)
}
